export default {
    baseStyle: {
        page: {
            background: 'gray.100',
            padding: {base: '15px', lg: '60px 60px 60px 24px'},
            marginBottom: '0px'
        },
        flex: {
            direction: {base: 'column', lg: 'row'},
            align: {base: 'center', lg: 'flex-start'},
            justify: 'center',
            gap: {base: '30px', lg: '60px'}
        },
        leftBox: {
            main: {
                flex: '1',
                paddingRight: {lg: '24px'},
                textAlign: 'center',
                width: '100%',
                mixBlendMode: 'multiply'
            }
        },
        rightBox: {
            swiperWrapper: {
                sx: {
                    '.swiper-slide': {
                        marginRight: {base: '5px !important', lg: '8.77px !important'},
                        width: {base: '108px !important', lg: '83px !important'},
                        height: {base: '134px', lg: '104px'},
                        cursor: 'pointer',
                        flexShrink: 0
                    },
                    '.swiper-wrapper': {
                        display: 'inline-flex'
                    },
                    '.swiper': {
                        paddingTop: '25px !important',
                        marginBottom: '-5px',
                        paddingBottom: {base: '30px !important', lg: '0px !important'},
                        marginRight: {base: '-15px', lg: '0px'}
                    }
                }
            },
            thumbnailBox: {
                position: 'relative',
                borderRadius: '4px',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                transition: 'border 0.3s ease',
                _hover: {
                    border: '1px solid',
                    borderColor: 'gray.800'
                },
                sx: {
                    img: {
                        minWidth: '83px'
                    }
                }
            },
            gradient: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: '4px',
                background: 'thumbnailGradient',
                zIndex: 1
            },
            thumbnailImage: {
                position: 'relative',
                zIndex: 0,
                width: {base: '108px', lg: '83px'},
                height: {base: '134px', lg: '104px'}
            },
            cardTitle: {
                fontFamily: 'heading',
                color: 'black.100',
                fontSize: {base: '23px', lg: '26px'},
                fontWeight: '400',
                letterSpacing: {base: '0.115px', lg: '0.13px'}
            },
            priceRange: {
                color: 'black.100',
                fontSize: '23px',
                fontWeight: '400',
                letterSpacing: '0.115px',
                fontFamily: 'heading'
            },
            label: {
                fontSize: '16px',
                color: 'black.100',
                fontWeight: '400',
                lineHeight: '25px',
                letterSpacing: '0.08px'
            },
            value: {
                fontSize: '16px',
                color: 'black.100',
                fontWeight: '300',
                lineHeight: '25px',
                letterSpacing: '0.08px'
            },
            amountSwatches: {
                main: {
                    justify: 'left',
                    gap: '20px 15px',
                    wrap: 'wrap',
                    mt: '20px'
                },
                swatch: {
                    borderRadius: '3px',
                    padding: '10px 18px',
                    cursor: 'pointer',
                    fontWeight: '300',
                    letterSpacing: '0.08px',
                    lineHeight: '25px',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    border: '1px solid',
                    borderColor: 'transparent',
                    _hover: {
                        borderColor: 'gray.900'
                    }
                }
            },
            form: {
                main: {
                    spacing: '30px',
                    sx: {
                        'input, textarea': {
                            padding: '20px 15px 6px'
                        },
                        textarea: {
                            height: '112px'
                        }
                    }
                },
                fields: {
                    main: {
                        spacing: '0px'
                    },
                    labelColor: {
                        color: 'black.100',
                        fontFamily: 'inter',
                        fontSize: '16px',
                        fontWeight: '400',
                        lineHeight: '25px',
                        letterSpacing: '0.08px'
                    },
                    personBox: {
                        gap: '15px',
                        width: '100%',
                        display: 'grid',
                        sx: {
                            '#personalizedMessage-label': {
                                zIndex: 1,
                                background: 'white',
                                width: '92%'
                            }
                        }
                    },
                    fieldBox: {
                        display: 'inline-flex',
                        gap: '15px'
                    }
                }
            },
            balanceCheck: {
                main: {
                    display: 'inline-flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '20px 30px',
                    backgroundColor: 'gray.400'
                },
                label: {
                    color: 'black.100',
                    fontFamily: 'heading',
                    fontSize: '20px',
                    fontWeight: '400',
                    letterSpacing: '0.1px'
                },
                link: {
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    transition: 'color 0.3s ease',
                    _hover: {
                        color: 'teal.600'
                    },
                    fontSize: '16px',
                    color: 'black.100',
                    fontWeight: '300',
                    lineHeight: '25px',
                    letterSpacing: '0.08px'
                }
            },
            instructionsText: {
                sx: {
                    p: {
                        width: '400px',
                        fontSize: '14px',
                        fontWeight: '300',
                        lineHeight: '22px',
                        letterSpacing: '0.07px'
                    }
                }
            },
            accordionBtn: {
                text: {
                    fontFamily: 'heading',
                    fontSize: {base: '23px', lg: '26px'},
                    fontWeight: '400',
                    lineHeight: 'normal',
                    letterSpacing: {
                        base: '0.115px',
                        color: 'black',
                        lg: '0.13px'
                    }
                },
                main: {
                    paddingTop: '30px',
                    paddingBottom: '15px'
                }
            },
            termsConditions: {
                fontSize: '13px',
                fontWeight: '300',
                lineHeight: '22px',
                letterSpacing: '0.065px',
                color: 'black.100',
                sx: {
                    a: {
                        textDecoration: 'underline',
                        textUnderlineOffset: '4px',
                        transition: 'color 0.3s ease',
                        _hover: {
                            color: 'teal.600'
                        }
                    }
                }
            },
            addToBag: {
                height: '56px',
                type: 'submit',
                backgroundColor: 'teal.500',
                _hover: {
                    backgroundColor: 'teal.400'
                },
                color: 'white',
                fontSize: '17px',
                fontWeight: '400',
                lineHeight: '26px',
                marginTop: '-15px',
                letterSpacing: '0.085px'
            },
            notEligibleText: {
                sx: {
                    div: {
                        fontSize: '16px',
                        fontWeight: '400',
                        color: 'black.100',
                        margin: '0px',
                        lineHeight: '22px',
                        letterSpacing: '0.08px'
                    }
                }
            },
            finalSalesText: {
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '22px',
                color: 'black.100',
                letterSpacing: '0.08px'
            },
            textBelowAddToBag: {
                textAlign: 'center',
                marginTop: '-15px',
                gap: '5px',
                marginBottom: '30px'
            },
            charactersRemaining: {
                fontSize: '14px',
                color: 'black.100',
                marginTop: '-5px',
                fontWeight: '300',
                letterSpacing: '0.07px'
            },
            globaleNotAvailable: {
                textAlign: 'center',
                borderWidth: '1px',
                borderStyle: 'solid',
                padding: '14px 3%',
                display: 'inline-flex'
            },
            cardSelectedDesign: {
                display: 'inline-flex',
                gap: '15px',
                marginTop: {base: '10px', lg: '30px'}
            },
            cardSelectedAmount: {
                display: 'inline-flex',
                gap: '10px',
                marginTop: {base: '15px', lg: '30px'}
            }
        }
    }
}
